var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01468 6.77406L10.725 10.1859C10.725 10.1859 10.2062 13.3847 8.33218 14.8772C6.45812 16.3703 0 15.9434 0 15.9434C0 15.9434 0.11875 15.2203 0.34375 14.2112L3.30062 10.7059C3.42468 10.5591 3.27343 10.3428 3.09281 10.409L1.20531 11.0994C1.65656 9.79749 2.22781 8.59811 2.91156 8.05343C4.78562 6.56093 8.01468 6.77406 8.01468 6.77406ZM19.8915 0.969687L19.2709 0.188438C19.0993 -0.0271866 18.7859 -0.0631241 18.5706 0.108438L11.3056 5.66468L10.2387 4.32187C10.0797 4.12156 9.76561 4.15906 9.6578 4.39093L8.86624 6.09562L11.5765 9.50749L13.414 9.11843C13.664 9.06561 13.7709 8.76843 13.6122 8.56843L12.5469 7.22718L19.8118 1.67094C20.0272 1.49969 20.0631 1.18562 19.8915 0.969687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.fc74af32826108a10cd9bd0d20181cba.svg";
export { ForwardRef as ReactComponent };